export default "__VITE_ASSET__9AA9629P__"